import React from "react";
// Material UI

import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";

//redux
import { connect } from "react-redux";
import { changePage, toggleDesigner, toggle3DDesigner } from "../redux_store/appState";
import { updateAreaSpecification } from "../redux_store/jobState";
import { Tooltip } from "@material-ui/core";
const mapStateToProps = (state) => ({
    job: state.job,
});

const importedActions = { changePage, toggleDesigner, toggle3DDesigner, updateAreaSpecification };
class AreaSelectField extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    setOpen = (state) => {
        this.setState({ open: state });
    };
    handleClose = () => {
        this.setOpen(false);
    };

    handleOpen = () => {
        this.setOpen(true);
    };

    render() {
        const { open } = this.state;
        const { props } = this;
        const {
            classes,
            style,
            selectStyle,
            labelStyle,
            helperText,
            helperTextStyle,
            onChange,
            areaIndex,
            section,
            dataField,
            value,
            label = null,
            valueKey = "Key",
            displayKey = "Display",
            items,
            refresh_svg = false,
            dark,
        } = props;

        let menu_items = [];
        if (items && Array.isArray(items)) {
            for (let menuItem of items) {
                if (typeof menuItem === "string" || typeof menuItem === "number") {
                    menu_items.push(
                        <MenuItem key={menuItem} value={menuItem} disabled={menuItem.disabled}>
                            {menuItem}
                        </MenuItem>
                    );
                } else if (React.isValidElement(menuItem)) {
                    menu_items.push(menuItem);
                } else if (typeof menuItem === "object") {
                    menu_items.push(
                        <MenuItem key={menuItem[valueKey]} value={menuItem[valueKey]} disabled={menuItem.disabled}>
                            {menuItem[displayKey]}
                        </MenuItem>
                    );
                    // menu_items.push(
                    //         <MenuItem key={menuItem[valueKey]} value={menuItem[valueKey]} disabled={menuItem.disabled}>
                    //             {menuItem[displayKey]}
                    //         </MenuItem>
                    // );
                }
            }
        } else if (typeof items === "object") {
            for (let key in items) {
                menu_items.push(
                    <MenuItem key={key} value={key}>
                        &nbsp;{key}
                    </MenuItem>
                );
            }
        }

        let default_style = { width: "100%", textAlign: "left" };
        if (!label) default_style = { width: "100%", textAlign: "left", marginTop: "0px" };

        return (
            <>
                <FormControl style={style ? { ...default_style, ...style } : default_style}>
                    <InputLabel
                        htmlFor="roofsheetType"
                        shrink={true}
                        style={labelStyle ? labelStyle : {}}
                        className={dark ? "" : classes.whiteText}
                        // FormLabelClasses={classes}
                        classes={{
                            // root: classes.cssLabel,
                            focused: classes.focussed,
                        }}
                        disabled={props.disabled}
                        // color="secondary"
                    >
                        {label}
                    </InputLabel>
                    <Select
                        //   open={open}
                        //   onClose={this.handleClose}
                        //   onOpen={this.handleOpen}
                        disabled={props.disabled}
                        style={selectStyle ? selectStyle : !label ? { marginTop: "0px" } : {}}
                        value={value}
                        className={dark ? classes.selectDark : classes.select}
                        onChange={(event) => {
                            onChange
                                ? onChange(event)
                                : this.props.updateAreaSpecification(areaIndex, section, dataField, event.target.value);
                        }}
                        name={section + "." + dataField}
                        classes={{
                            select: props.clip_overflow ? classes.clip_overflow : null,
                        }}
                        input={
                            <Input
                                classes={{
                                    focused: classes.orangeText,
                                    underline: classes.underline,
                                }}
                                name="roofsheetType"
                                id="roofsheetType"
                            />
                        }
                        // classes={classes}
                    >
                        {menu_items}
                    </Select>
                    {helperText && <FormHelperText>{helperText}</FormHelperText>}
                </FormControl>
            </>
        );
    }
}
AreaSelectField.propTypes = {
    // ...prop type definitions here
    items: PropTypes.any.isRequired,
    /// values can just ba a string array
    /// but if it is an object array, you need to specify valueKey and displayKey
    // valueKey: PropTypes.string.isRequired,
    // displayKey: PropTypes.string.isRequired,
};

const styles = {
    whiteText: {
        color: "white",
        // backgroundColor: '#21cfe72b',
        // borderRadius: '9px',
        // padding: '4px',
        // width: '127%',
        "&:focus": {
            fontSize: "10px",
            color: "#c1c1c2",
        },
    },
    orangeText: {
        color: "orange",
        "&:focus": {
            fontSize: "10px",
            color: "#c1c1c2",
        },
    },
    underline: {
        borderBottomColor: "orange",
        "&:after": {
            // The MUI source seems to use this but it doesn't work
            borderBottomColor: "orange",
        },
        "&:before": {
            // The MUI source seems to use this but it doesn't work
            borderBottom: "none",
        },
    },
    cssLabel: {
        focused: {
            color: "orange",
        },
        cssFocused: {
            color: "orange",
        },
    },
    selectDark: {
        color: "black",
        textAlign: "center",
        textOverflow: "clip",
        focused: {
            color: "orange",
        },
    },
    select: {
        color: "white",
        textAlign: "center",
        textOverflow: "clip",
        focused: {
            color: "orange",
        },
    },
    clip_overflow: {
        textOverflow: "clip",
    },
    focussed: {
        color: "orange !important",
    },
};
export default connect(mapStateToProps, importedActions)(withStyles(styles)(AreaSelectField));
